export const account = {

    // --- My account (new settings screen: menu.vue + AccountWelcome.vue) ---
    mc_title: `Il mio account`,
    mc_subtitle: `Le impostazioni del tuo account e della tua attività`,
    mc_group_account: `Account`,
    mc_home: `Home`,
    mc_mydata: `I miei dati`,
    mc_subscription: `Abbonamento`,
    mc_billing: `Fatturazione elettronica`,
    mc_whatsapp: `WhatsApp Business`,
    mc_notifications: `Notifiche`,
    mc_team: `Gestione del team`,
    mc_team_badge: `Novità`,
    mc_integrations: `Integrazioni`,
    mc_hello: `Ciao`,
    mc_welcome_sub: `Benvenuto nel tuo account. Da qui gestisci i dati della tua attività e le impostazioni che il sistema utilizza per lavorare al posto tuo.`,
    mc_quick: `Accesso rapido`,
    mc_card_account_title: `Impostazioni dell'account`,
    mc_card_account_desc: `Dati di contatto, lingua del pannello e sicurezza.`,
    mc_card_subscription_desc: `Il tuo piano e la fatturazione dell'abbonamento.`,
    mc_card_billing_desc: `Emittenti fiscali e quale emittente fattura ciascun alloggio.`,
    mc_card_whatsapp_desc: `La connessione che il sistema utilizza per comunicare con i tuoi ospiti.`,
    mc_card_notifications_desc: `Quali avvisi ricevi e attraverso quali canali.`,
    mc_card_team_desc: `Invita collaboratori e gestisci i loro permessi.`,
    mc_card_integrations_desc: `Connessioni con servizi esterni.`,

  p1: `Gestisci il tuo account`,
  p2: `Impostazioni dell'account`,
  p3: `Lingua`,
  p4: `Accesso e sicurezza`,
  p5: `Il mio abbonamento`,
  p6: `Informazioni di fatturazione`,
  p7: `WhatsApp Business`,
  p8: `Integrazioni`,
  p9: `Impostazioni dell'account`,
  p10: `Gestisci i recapiti a cui riceverai tutte le comunicazioni da WACheckin.`,
  p11: `Dati aggiornati con successo`,
  p12: `Lingua della piattaforma`,
  p13: `Seleziona la lingua preferita per il tuo pannello di controllo. Questa impostazione non influisce sulla lingua del check-in che ricevono i tuoi ospiti, poiché dipende dalle impostazioni del loro dispositivo.`,
  p14: `Seleziona la lingua dall'elenco`,
  p15: `Seleziona la lingua`,
  p16: `Spagnolo`,
  p17: `Inglese`,
  p18: `Aggiorna la lingua`,
  p19: `Lingua applicata con successo`,
  p20: `Qui puoi aggiornare la tua password per mantenere sicuro il tuo account.`,
  p21: `Vuoi cambiare la tua password?`,
  p22: `Cambia password`,
  p23: `Controlla la tua email`,
  p24: `Per procedere con il cambio della password, controlla la tua casella di posta e segui i passaggi`,
  p25: `Continua`,
  p26: `Ops! Si è verificato un errore imprevisto`,
  p27: `Dati aggiornati con successo`,
  p28: `WhatsApp for Business`,
  p29: `Collega il tuo account WhatsApp Business alla nostra piattaforma e invia messaggi ai tuoi ospiti direttamente dal tuo numero personalizzato.`,
  p30: `Nessun account collegato.`,
  p31: `Collega account`,
  p32: `Account`,
  p33: `Collegato`,
  p34: `Scollega account`,
  p35: `Caricamento informazioni...`,
  p36: `Scollega WhatsApp for Business`,
  p37: `Stai pensando di scollegare WhatsApp for Business e di smettere di inviare messaggi ai tuoi ospiti tramite WhatsApp?`,
  p38: `Scollega`,
  p39: `Account WhatsApp Business scollegato con successo`,
  p40: `Impossibile scollegare l'account WhatsApp Business, contatta l'assistenza`,
  p41: `Numero di telefono`,
  p42: `Account Facebook`,
  p43: `Dati dell'attività`,
  p44: `Devi avere un numero di telefono valido e univoco per utilizzarlo con l'API di WhatsApp Business.`,
  p45: `Riceverai un codice di verifica per autenticare il tuo numero sulla nostra piattaforma.`,
  p46: `Il numero di telefono della tua attività deve essere un numero valido che soddisfa i criteri della`,
  p47: `piattaforma WhatsApp for Business.`,
  p48: `Riceverai un codice di verifica per autenticare il tuo numero sulla nostra piattaforma.`,
  p49: `Torna allo stato dell'account`,
  p50: `Continua`,
  p51: `Devi avere un account Facebook personale (collegato all'email della tua attività)`,
  p52: `Se hai creato e collegato un account Facebook Business a questo sistema, devi autenticarlo prima di avviare il processo di onboarding facendo clic su Accedi con Facebook.`,
  p53: `Per autenticare il tuo account aziendale, apri`,
  p54: `questo link`,
  p55: `in una scheda separata.`,
  p56: `Devi generare un codice nella tua app di autenticazione e inserirlo nel campo "Inserisci codice".`,
  p57: `Una volta confermato, puoi chiudere questa scheda.`,
  p58: `Torna allo stato dell'account`,
  p59: `Indietro`,
  p60: `Continua`,
  p61: `Prepara i dati della tua attività`,
  p62: `Devi avere a portata di mano le informazioni della tua attività: la ragione sociale e l'indirizzo della tua azienda, nonché l'account aziendale così come vuoi che venga visualizzato.`,
  p63: `Devi avere un sito web aziendale valido.`,
  p64: `Devi verificare il tuo account con Meta il prima possibile. Un'attività verificata può iniziare inviando 1000 messaggi al giorno. Se non verifichi il tuo account, Meta lo disattiverà.`,
  p65: `Secondo le policy di Meta, un account aziendale non verificato può essere collegato solo a due numeri. Verifica l'account per collegarlo a più numeri.`,
  p66: `Torna allo stato dell'account`,
  p67: `Indietro`,
  p68: `Continua`,
  p69: `Account WhatsApp Business collegato con successo`,

  p70: `Fatturazione`,
  p71: `Stato`,
  p72: `Importo addebitato`,
  p73: `Pagato`,
  p74: `In sospeso`,
  p75: `Visualizza fattura`,
  p76: `Nessun record di fatturazione trovato`,
  p77:`Data`,
  p78: ``,
  p79: ``,
  p80: ``,
};
